<template>
    <div>
      <div class="layout-w container-cliente">
        <div class="container">
          <ul class="breadcrumb d-print-none">
              <li class="breadcrumb-item">
                  <router-link :to="{name: 'Home'}">Página Principal</router-link>
              </li>
              <li class="breadcrumb-item">
                  <span>Área do Cliente</span>
              </li>
          </ul>
          <div class="element-wrapper pb-0">
            <div class="element-wrapper pb-0">
                <h3 class="element-header">
                  Meu Dr.Achei
                </h3>
            </div>
          </div>
           <div class="container">
            <div class="row">
              <div class="col-md-2">
                <div class="">
                  <div class="profile-tile">
                    <div class="profile-tile-box">
                      <div class="pt-avatar-w">
                        <img alt="" src="@/img/icon-drachei-alpha.svg">
                      </div>
                      <div class="pt-user-name">
                        <h6>{{user.name}}</h6>
                      </div>
                      <div class="value-pair">
                        <div class="label">
                          Status:
                        </div>
                        <div class="value badge badge-pill badge-success">
                          Ativo
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div class="menu-w color-style-transparent menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link">
                  <ul class="main-menu">
                    <li class="selected">
                      <router-link tag="a" :to="{name: 'MeusDadosCliente' }">
                        <div class="icon-w">
                          <div class="os-icon os-icon-user-male-circle"></div>
                        </div>
                        <span>Meus Dados</span>
                      </router-link>
                    </li>
                    <li class="selected">
                      <router-link tag="a" :to="{name: 'HomeAdmCliente' }">
                        <div class="icon-w">
                          <div class="os-icon os-icon-phone-21"></div>
                        </div>
                        <span>Pedidos</span>
                      </router-link>
                    </li>
                    <li class="selected">
                      <router-link tag="a" :to="{name: 'AvaliacoesCliente' }">
                        <div class="icon-w">
                          <div class="os-icon os-icon-ui-02"></div>
                        </div>
                        <span>Avaliações</span>
                      </router-link>
                    </li>
                    <li class="selected">
                      <router-link tag="a" :to="{name: 'ProntuarioCliente' }">
                        <div class="icon-w">
                          <div class="os-icon os-icon-newspaper"></div>
                        </div>
                        <span>Prontuário</span>
                        
                      </router-link>
                    </li>
                    <li class="selected">
                      <a @click="logout()" href="" class="text-danger">
                        <div class="icon-w">
                          <div class="os-icon os-icon-signs-11"></div>
                        </div>
                        <span>Sair</span></a>
                    </li>
                    
                  </ul>
                </div>
              </div>
              <transition name="content" mode="out-in">
                <router-view></router-view>
              </transition>
              
            </div>
           </div>
        </div>
        
      </div>
      <div class="footer-menu-mobile fixed-bottom d-block d-sm-none">
          <nav class="nav nav-pills nav-justified">
            <router-link tag="a" class="nav-item nav-link" :to="{name: 'MeusDadosCliente' }"><div class="os-icon os-icon-user-male-circle"></div> Meus Dados</router-link>
            <router-link tag="a" class="nav-item nav-link active" :to="{name: 'HomeAdmCliente' }"><div class="os-icon os-icon-phone-21"></div> Pedidos</router-link>
            <router-link tag="a" class="nav-item nav-link" :to="{name: 'AvaliacoesCliente' }"><div class="os-icon os-icon-ui-02"></div> Avaliações</router-link>
            <router-link tag="a" class="nav-item nav-link" :to="{name: 'Prontuarios' }"><div class="os-icon os-icon-ui-02"></div> Prontuário</router-link>
          </nav>
        </div>
    </div>
</template> 

<script>
import MenuAdmin from '@/components/pages/dashboard/MenuAdmin'

export default {
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  components: {
    'menu-admin': MenuAdmin
  },
  methods: {
    logout () {
      if (this.user && this.user.role === 'DRACHEI') {
        this.$store.dispatch('logout')
      } else {
        this.$store.dispatch('logout')
          .then(() => this.$router.push({name: 'Login'}))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard-cliente/DashboardCliente.vue